import { useMessagingDrawer } from './hooks';
import { GuestMessagingDrawer } from './GuestMessagingDrawer';
import { MassMessageMessagingDrawer } from './MassMessageMessagingDrawer';

export const MessagingDrawer = () => {
  const { guestIds, walkInIds, isOpen } = useMessagingDrawer();

  const totalOccupants = guestIds.length + walkInIds.length;
  const isSendingMassMessage = totalOccupants > 1;
  if (isSendingMassMessage) {
    return (
      <MassMessageMessagingDrawer
        isOpen={isOpen}
        guestIds={guestIds}
        walkInIds={walkInIds}
      />
    );
  } else {
    return (
      <GuestMessagingDrawer
        isOpen={isOpen}
        guestId={guestIds[0] || walkInIds[0]}
      />
    );
  }
};
